import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { CalendarOutlined, RightOutlined } from '@ant-design/icons';
import { imgUrl } from '@/shared/utils';
import { HomeArticleModel } from '@/types/home';
import styles from './index.module.less';

interface ArticleCardProps {
  article: HomeArticleModel;
}

const ArticleCard = ({ article }: ArticleCardProps) => {
  const href = `/blog/${article.title_id}`;
  const hasCoverImage = article.cover_image && article.cover_image.trim();

  return (
    <Link href={href} className={styles.articleCard}>
      <article className={styles.cardContainer}>
        <div className={styles.cardContent}>
          {/* 左侧内容区 */}
          <div className={styles.contentSection}>
            <div className={styles.textSection}>
              <div className={styles.cardTitle}>{article.title}</div>
              {article.description && <p className={styles.cardDescription}>{article.description}</p>}
            </div>
            <div className={styles.cardFooter}>
              {article.create_time && (
                <div className={styles.cardDate}>
                  <CalendarOutlined className={styles.dateIcon} />
                  <time>{article.create_time}</time>
                </div>
              )}
              <span className={styles.readMore}>
                Read More <RightOutlined className={styles.readMoreIcon} />
              </span>
            </div>
          </div>
          {/* 右侧图片区 */}
          {hasCoverImage && (
            <div className={styles.imageSection}>
              <Image
                src={imgUrl(article.cover_image, 'mid')}
                alt={article.title || 'Article cover'}
                fill
                className={styles.cardImage}
                sizes="(max-width: 768px) 100vw, 33vw"
              />
            </div>
          )}
        </div>
      </article>
    </Link>
  );
};

const ArticleListContent = ({ articleList }: { articleList?: any }) => {
  if (!articleList || articleList.length === 0) {
    return null;
  }

  return (
    <>
      {articleList.map((item: HomeArticleModel, index: number) => (
        <ArticleCard key={item?.title_id || index} article={item} />
      ))}
    </>
  );
};

export default ArticleListContent;
